import React from 'react';
import { useTranslation } from 'react-i18next';
import { HtmlTrans, SectionHeader, Typography } from 'web-library';
import { Theme as AugmentedTheme } from '@mui/material';


import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) =>
({
  a: {
    textDecoration: 'none',
    color: theme.color.link.linkDefault01,
  },
}));

const PsleInstruction = () => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  return (
    <>
      <SectionHeader title={t('exam->>RegisterExamInstructions.PSLEInstructionsTitle')} />

      <ul>
        <li>
          <Typography variant="body1">
            {t('exam->>RegisterExamInstructions.PSLEInstructions1')}
          </Typography>
          <ol type="a">
            <li>
              <Typography variant="body1">
                {t('exam->>RegisterExamInstructions.PSLEInstructions1Sub1')}
              </Typography>
            </li>
            <li>
              <Typography variant="body1">
                {t('exam->>RegisterExamInstructions.PSLEInstructions1Sub2')}
              </Typography>
            </li>
          </ol>
        </li>
        <li>
          <Typography variant="body1">
            {t('exam->>RegisterExamInstructions.PSLEInstructions2')}
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            {t('exam->>RegisterExamInstructions.PSLEInstructions3')}
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            {t('exam->>RegisterExamInstructions.PSLEInstructions4')}
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            {t('exam->>RegisterExamInstructions.PSLEInstructions5')}
          </Typography>
        </li>
        <li>
          <Typography variant="body1">
            <HtmlTrans
              i18nKey="exam->>RegisterExamInstructions.PSLEInstructions6"
              values={{
                aClass: classes.a,
              }}
            />
          </Typography>
        </li>
      </ul>
    </>
  );
};
export default PsleInstruction;
